import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import moment from "moment";

import { FormField } from "../../../sharedComponents/formField";
import { PanelBody, PanelFooter } from "../../../sharedComponents/filterPanel";
import { saveFitnessGoals, createFitnessGoals } from "../../../store/actions/index";
import { isInt } from "../../../constants/formValidators";

import { goalFields } from "./helper";

const SetGoals = ({ initialValues, handleSubmit, saveFitnessGoals, onUpdate, toggle, createFitnessGoals }) => {
	const validateForm = (values) => {
		const successHandler = (event) => {
			onUpdate(event);
		};

		initialValues && initialValues.id
			? saveFitnessGoals(
				{ ...values, date: moment(values.date).format("YYYY/MM/DD"), id: initialValues.id },
				successHandler
			)
			: createFitnessGoals({ ...values, date: moment().format("YYYY/MM/DD") }, successHandler);
	};

	return (
		<form className="flex-fill d-flex flex-column" onSubmit={handleSubmit(validateForm)}>
			<PanelBody>
				<div className="row">
					{initialValues &&
						goalFields &&
						goalFields.length > 0 &&
						goalFields.map(({ name, label }, index) => {
							return (
								<Field key={index} label={label} name={name} formGroupClass="col-12" validate={[isInt]} component={FormField} />
							);
						})}
				</div>
			</PanelBody>
			<PanelFooter className="sticky-footer py-0">
				<div className="text-right pt-3 pb-3">
					<button className="btn btn-default" type="button" onClick={toggle}>
						Cancel
					</button>
					<button className="btn btn-primary-dark text-uppercase" type="submit">
						Save
					</button>
				</div>
			</PanelFooter>
		</form>
	);
};

const mapDispatchToProps = {
	saveFitnessGoals,
	createFitnessGoals
};

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "SetGoalsForm",
		enableReinitialize: true
	})(SetGoals)
);
